<template>
  <span class="fleet-menu-item" :title="hover" :data-testid="sectionTag">
    <span>{{ title }}</span>
    <span v-if="reason" class="fleet-menu-item__reason">{{ reason }}</span>
  </span>
</template>

<script setup lang="ts">
/** A flyout item's title, with the reason it is off under it: a disabled item takes no hover, so a hover alone is never read. */
defineProps<{ title: string; reason?: string; hover?: string; sectionTag?: string }>()
</script>

<style scoped>
.fleet-menu-item {
  display: flex;
  flex-direction: column;
}

.fleet-menu-item__reason {
  font-size: 12px;
  color: var(--color-content-text-muted, #767676);
}
</style>
